import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { serialNumbersService } from 'services';
import { ROUTES } from 'constants/routes';
import { CustomButton, Spinner } from 'components';

import './SerialNumbersList.scss';
import { SerialNumber } from '../../interfaces/serialNumber';
import { SERIAL_NUMBERS_LIST_FIELDS } from '../../constants/serialNumbersListFields';

export const SerialNumbersList = () => {
  const [serialsList, setSerialsList] = useState<[] | SerialNumber[]>([]);
  const [isListLoading, setIsListLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  async function downloadExcel() {
    const response = await serialNumbersService.excel();
    const fileURL = window.URL.createObjectURL(response as Blob);
    const alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = `Registrations_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    alink.click();
  }

  useEffect(() => {
    (async () => {
      setIsListLoading(true);

      try {
        const response = await serialNumbersService.listSerials();
        if (response) {
          setIsListLoading(false);
          setSerialsList(response);
        }
      } catch (e) {
        setIsListLoading(false);
      }
    })();
  }, []);

  return (
    <div className="serial-numbers-list-container">
      <div className="serial-numbers-list__header-box">
        <h6 className="serial-numbers-list__header">Registration History</h6>
        <div>
          <CustomButton
            height="40px"
            text="Export to Excel"
            onClick={() => downloadExcel()}
          />
        </div>
      </div>
      <div className="serial-numbers-list__fields">
        {SERIAL_NUMBERS_LIST_FIELDS.map(({ name }) => (
          <div key={name} className="serial-numbers-list__field">
            <p className="serial-numbers-list__text">{name}</p>
          </div>
        ))}
      </div>
      <div className="serial-numbers-list__data-container">
        {serialsList.length !== 0 &&
          !isListLoading &&
          serialsList.map(
            ({
              sn,
              sn_partner,
              id_code,
              imo_nr,
              schiffsname,
              commissioning_date,
              validity,
            }) => (
              <div key={sn} className="serial-numbers-list__data-box">
                <p className="serial-numbers-list__data-item">{sn}</p>
                <p className="serial-numbers-list__data-item">{sn_partner}</p>
                <p className="serial-numbers-list__data-item">{id_code}</p>
                <p className="serial-numbers-list__data-item">{imo_nr}</p>
                <p className="serial-numbers-list__data-item">{schiffsname}</p>
                <p className="serial-numbers-list__data-item">
                  {commissioning_date}
                </p>
                <p className="serial-numbers-list__data-item">{validity}</p>
                <p className="serial-numbers-list__data-item">
                  <span
                    onClick={() =>
                      navigate(`${ROUTES.documents_overview}/${sn}`)
                    }
                  >
                    Details
                  </span>
                </p>
              </div>
            )
          )}
        {!serialsList.length && !isListLoading && (
          <div className="serial-numbers-list__empty">Your list is empty</div>
        )}
        {isListLoading && (
          <div className="serial-numbers-list__spinner-box">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
